/* eslint-disable */
// Stream Router and Enhanced Wowza mutations for streaming functionality

export const createStreamRouterInterface = `mutation CreateStreamRouterInterface(
  $streamRouterId: String!
  $interfaceData: StreamRouterInterfaceCreateInput!
) {
  createStreamRouterInterface(
    streamRouterId: $streamRouterId
    interfaceData: $interfaceData
  ) {
    success
    message
    dataJson
  }
}
`;

export const deleteStreamRouterInterface = `mutation DeleteStreamRouterInterface(
  $streamRouterId: String!
  $interfaceId: String!
) {
  deleteStreamRouterInterface(
    streamRouterId: $streamRouterId
    interfaceId: $interfaceId
  ) {
    success
    message
    dataJson
  }
}
`;

export const createExternalWowzaTarget = `mutation CreateExternalWowzaTarget(
  $serverId: String!
  $applicationId: String!
  $targetConfig: WowzaTargetConfigInput!
) {
  createExternalWowzaTarget(
    serverId: $serverId
    applicationId: $applicationId
    targetConfig: $targetConfig
  ) {
    success
    message
    dataJson
  }
}
`;

export const updateExternalWowzaTarget = `mutation UpdateExternalWowzaTarget(
  $serverId: String!
  $applicationId: String!
  $targetId: String!
  $targetConfig: WowzaTargetConfigInput!
) {
  updateExternalWowzaTarget(
    serverId: $serverId
    applicationId: $applicationId
    targetId: $targetId
    targetConfig: $targetConfig
  ) {
    success
    message
    dataJson
  }
}
`;

export const listWowzaAppTargets = `query ListWowzaAppTargets(
  $serverId: String!
  $applicationId: String!
) {
  listWowzaAppTargets(
    serverId: $serverId
    applicationId: $applicationId
  ) {
    success
    message
    dataJson
  }
}
`;

export const getWowzaAppTarget = `query GetWowzaAppTarget(
  $serverId: String!
  $applicationId: String!
  $targetId: String!
) {
  getWowzaAppTarget(
    serverId: $serverId
    applicationId: $applicationId
    targetId: $targetId
  ) {
    success
    message
    dataJson
  }
}
`;

export const listWowzaApplications = `query ListWowzaApplications(
  $serverId: String!
) {
  listWowzaApplications(serverId: $serverId) {
    success
    message
    dataJson
  }
}
`;

export const getWowzaApplication = `query GetWowzaApplication(
  $serverId: String!
  $applicationId: String!
) {
  getWowzaApplication(
    serverId: $serverId
    applicationId: $applicationId
  ) {
    success
    message
    dataJson
  }
}
`;

export const listTranscoderTemplates = `query ListTranscoderTemplates(
  $serverId: String!
  $applicationId: String!
) {
  listTranscoderTemplates(
    serverId: $serverId
    applicationId: $applicationId
  ) {
    success
    message
    dataJson
  }
}
`;

// Enhanced equipment query for Wowza servers
export const listEquipmentWowza = `query ListEquipment(
  $filter: ModelEquipmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listEquipments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      equipmentId
      name
      description
      equipmentType
      claimsCanAccess
      claimsCanEdit
    }
    nextToken
  }
}
`;
